var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnChevronSelector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57743 0.410826C4.90287 0.0853888 5.43051 0.0853888 5.75594 0.410826L9.92261 4.57749C10.248 4.90293 10.248 5.43057 9.92261 5.756C9.59717 6.08144 9.06954 6.08144 8.7441 5.756L5.16669 2.17859L1.58928 5.756C1.26384 6.08144 0.736202 6.08144 0.410765 5.756C0.0853278 5.43057 0.0853278 4.90293 0.410765 4.57749L4.57743 0.410826ZM0.410765 9.57749C0.736202 9.25206 1.26384 9.25206 1.58928 9.57749L5.16669 13.1549L8.7441 9.57749C9.06954 9.25206 9.59717 9.25206 9.92261 9.57749C10.248 9.90293 10.248 10.4306 9.92261 10.756L5.75594 14.9227C5.43051 15.2481 4.90287 15.2481 4.57743 14.9227L0.410765 10.756C0.0853278 10.4306 0.0853278 9.90293 0.410765 9.57749Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChevronSelector);
export default __webpack_public_path__ + "static/media/icn-chevron-selector.0ffc3ad3be56de6ea2b60a5a10e01640.svg";
export { ForwardRef as ReactComponent };